import { createContext, useContext } from 'react'

// Shares state from the script page's Assets side panel (e.g. the currently
// selected folder) with components rendered elsewhere in the editor tree —
// notably the character voice chips, which generate assets into that folder.
// Defaults are safe so consumers work even without a provider.
//
// `requestGeneration({ modelId, settings })` lets those same chips ask the page
// to reveal the Assets panel and preset its generator (model + payload props)
// without knowing anything about the AssetsEditor / AiModelInput internals.
const ScriptAssetsContext = createContext({
    destinationFolder: null,
    requestGeneration: () => {},
})

export function ScriptAssetsProvider({ destinationFolder = null, requestGeneration = () => {}, children }) {
    return (
        <ScriptAssetsContext.Provider value={{ destinationFolder, requestGeneration }}>
            {children}
        </ScriptAssetsContext.Provider>
    )
}

export function useScriptAssets() {
    return useContext(ScriptAssetsContext)
}
